import type { TFunction } from 'i18next';

import { COIN_BACK_DATA_TEST_ID, COIN_BACK_TUTORIAL_DATA_TEST_ID } from '../../../features/coinbackTutorial/constants';
import type { CoinType } from '../../../stores/cointype/CoinTypeStore';
import { floorToDecimals, formatValueWithKFloor } from '../../../utils/helpers';

// Coinback must never display more than the player actually collects, so GC
// floors at every tier instead of rounding, and SC is never K/M/B-abbreviated.
export const formatCoinBackBalanceValue = (value: number, coinType: CoinType, t: TFunction) => {
  if (coinType === 'GC') {
    if (value < 100000) {
      return floorToDecimals(value, 2).toLocaleString();
    } else {
      const formattedWithK = formatValueWithKFloor(value, t);
      return formattedWithK.toLocaleString();
    }
  } else {
    return (Math.floor(Number((value * 100).toFixed(6))) / 100).toLocaleString();
  }
};

export const getCoinBackDataTestId = (suffix: string, isTutorialOpen: boolean): string => {
  const baseTestId = isTutorialOpen ? COIN_BACK_TUTORIAL_DATA_TEST_ID : COIN_BACK_DATA_TEST_ID;
  return `${baseTestId}-${suffix}`;
};
